<template>
  <div class="border-b border-neutral-200 px-4 py-5 sm:px-6">
    <slot>
      <div class="flex flex-wrap items-center justify-between gap-y-2">
        <h3 class="min-w-fit flex-1 text-lg font-medium leading-6 text-neutral-900">{{ title }}</h3>
        <div class="ml-4 flex min-w-fit flex-wrap items-start justify-start gap-4 print:hidden">
          <slot name="actions"></slot>
          <router-link v-if="viewAllTo" class="text-sm text-sky-500 hover:underline" :to="viewAllTo"
            >View All</router-link
          >
        </div>
      </div>
    </slot>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";
import type { RouteLocationAsPathGeneric, RouteLocationAsRelativeGeneric } from "vue-router";

export default defineComponent({
  name: "LandingCard",
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
    viewAllTo: {
      type: Object as PropType<string | RouteLocationAsRelativeGeneric | RouteLocationAsPathGeneric>,
      required: false,
      default: null,
    },
  },
});
</script>
